export const keywords =
  'itr filing, itr e-filing, income tax e filing, itr efiling, income tax filing, income tax return filing, itr filing for ay 2025-26, itr filing online, income tax e filing portal, cleartax itr filing, itr login, income tax login, e filing income tax login, last date for filing itr 2026';

export const canonical = 'https://cleartax.in/income-tax-efiling';

export const description =
  'ITR Filing for FY 2025-26 (AY 2026-27): e-Filing of Income Tax Returns online made easy with ClearTax to get maximum tax refund. Income Tax login, upload Form-16, view/download Form 26AS, review your TDS deductions & track refund status for Income Tax Filing in India.';

export const pageTitle =
  'Income Tax e Filing for FY 2025-26 (AY 2026-27) | Upload Form-16 for eFiling Income Tax Returns | ITR Filing - ClearTax';
export const brandName = 'Income Tax e-filing';
